import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import OutlierDetectorTableDto from '../dto/OutlierDetectorTableDto';

class OutlierDetectorTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'outlierDetectorTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<OutlierDetectorTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, { session, firstResult, maxResults })
				.then(response => resolve(new GenericTableDto().setup(response.data, OutlierDetectorTableDto)))
				.catch(reject);
		});
	}
}

export default new OutlierDetectorTableService();